<template>
  <div
    v-if="pageInfo && pageInfo.totalPages > 1"
    class="flex flex-row justify-center sm:justify-between items-center my-4"
  >
    <RmLink
      :class="pageInfo.currentPage === 1 ? 'invisible' : 'visible'"
      :to="generateLink(1)"
      class="mr-3 rounded-[10px] text-sm font-bold !hidden md:!flex"
      color="transparent"
      @click="handleClickToStart"
    >
      В начало
    </RmLink>
    <nuxt-link
      v-if="pageInfo.currentPage > 3"
      :to="''"
      class="w-6 min-[360px]:mr-5 mr-4 border-2 border-gray-300 rounded-md h-6 flex flex-none md:hidden justify-center items-center cursor-pointer bg-white select-none text-sm font-bold text-black hover:bg-gray-300 active:bg-gray-200"
      @click="handleClickToStart"
    >
      1
    </nuxt-link>

    <div class="flex flex-row justify-between min-[360px]:gap-x-5 gap-x-4 items-center">
      <template v-for="(item, key) in visiblePageLinks">
        <nuxt-link
          v-if="item"
          :key="key"
          :to="generateLink(item)"
          :class="
            Number(pageInfo.currentPage) === Number(item)
              ? 'bg-yellow-500 text-black'
              : 'text-gray-400'
          "
          event=""
          class="w-6 h-6 flex justify-center items-center cursor-pointer bg-white select-none text-sm font-bold rounded-md hover:bg-gray-300 active:bg-gray-200"
          @click="handleChangePage(item)"
        >
          {{ item }}
        </nuxt-link>
        <div
          v-else
          :key="`${key}.`"
          class="w-7 h-7 flex justify-center items-center cursor-default bg-white text-gray-400 select-none text-sm font-bold rounded-md"
        >
          ...
        </div>
      </template>
    </div>
    <RmLink
      :class="!pageInfo.nextPage ? 'invisible' : 'visible'"
      :to="generateLink(pageInfo.nextPage)"
      class="rounded-[10px] text-sm font-bold !hidden sm:!flex"
      color="transparent"
      event=""
      @click="nextPage"
    >
      Дальше
    </RmLink>
  </div>
</template>

<script>
import isEmpty from 'es-toolkit/compat/isEmpty'
import RmLink from '~/components/shared/rm_link.vue'
export default {
  components: {
    RmLink,
  },
  setup () {
    const search = useSearch()
    const searchForm = useSearchForm()
    return {
      search,
      searchForm,
      selectedCategory: searchForm.selectedCategory,
      pageInfo: search.pageInfo,
      changeParams: searchForm.changeParams,
    }
  },
  computed: {
    visiblePageLinks () {
      const arrLinks = []

      for (let index = 1; index < this.pageInfo.totalPages + 1; index++) {
        arrLinks.push(index)
      }

      if (this.pageInfo.currentPage > 3) {
        arrLinks.splice(0, this.pageInfo.currentPage - 3, null)
      }

      if (this.pageInfo.currentPage + 2 < this.pageInfo.totalPages) {
        if (this.pageInfo.currentPage === 2) {
          arrLinks.splice(
            arrLinks.indexOf(this.pageInfo.currentPage) + 4,
            this.pageInfo.totalPages - arrLinks.indexOf(this.pageInfo.currentPage),
            null,
          )
        }

        if (this.pageInfo.currentPage === 1) {
          arrLinks.splice(
            arrLinks.indexOf(this.pageInfo.currentPage) + 5,
            this.pageInfo.totalPages - arrLinks.indexOf(this.pageInfo.currentPage),
            null,
          )
        }

        if (this.pageInfo.currentPage > 2) {
          arrLinks.splice(
            arrLinks.indexOf(this.pageInfo.currentPage) + 3,
            this.pageInfo.totalPages - arrLinks.indexOf(this.pageInfo.currentPage),
            null,
          )
        }
      }
      return arrLinks
    },
  },
  methods: {
    generateLink (number) {
      const params = Object.assign({}, this.$route.query)
      params.page = number
      const stringQuery = Object.keys(params)
        .filter(key => !(key === 'page' && params[key] === 1))
        .map(key => `${key}=${params[key]}`)
        .join('&')
      return `?${stringQuery}`
    },
    handleChangePage (page) {
      this.scrollToUp()
      this.search.setFromPagination(true)
      if (page === 1) {
        this.changeParams({ key: 'page', value: null })
      } else {
        this.changeParams({ key: 'page', value: page })
      }
    },
    prevPage () {
      this.scrollToUp()
      // this.changeParams({ key: 'page', value: this.pageInfo.prevPage })
    },
    nextPage () {
      this.scrollToUp()
      // this.changeParams({ key: 'page', value: this.pageInfo.nextPage })
    },
    handleClickToStart () {
      this.search.setFromPagination(true)

      const sortBy = this.$route.query.sort_by || 'RELEVANCE'
      const direction = this.$route.query.direction || 'DESC'
      const q = this.$route.query.q || ''
      const SORT_BY = sortBy ? sortBy.toUpperCase() + '_' + direction.toUpperCase() : ''

      const getItemCategory = useCategories().getItemCategory(
        this.selectedCategory.id,
      )
      const getItemCategory2 = useCategories().getItemCategory2(
        this.selectedCategory.id,
      )
      const getItemCategory3 = useCategories().getItemCategory3(
        this.selectedCategory.id,
      )
      const getItemCategory4 = useCategories().getItemCategory4(
        this.selectedCategory.id,
      )

      this.$tracking.logEventAmplitude('show more products', {
        'product list': this.selectedCategory.id && this.selectedCategory.id,
        'category depth': isEmpty(this.selectedCategory) ? 0 : this.selectedCategory.depth + 1,
        'category id': this.selectedCategory?.id && this.selectedCategory.id,
        'category name': this.selectedCategory?.name && this.selectedCategory.name,
        'category level 1 name': getItemCategory,
        ...(getItemCategory2 && {
          'category level 2 name': getItemCategory2,
        }),
        ...(getItemCategory3 && {
          'category level 3 name': getItemCategory3,
        }),
        ...(getItemCategory4 && {
          'category level 4 name': getItemCategory4,
        }),
        'sort type': SORT_BY,
        query: q,
        'num of products': this.pageInfo.totalCount,
        'load method': 'PAGINATION',
        'batch number': 1,
      })
      this.scrollToUp()
    },
    scrollToUp () {
      window.scrollTo(0, 0)
    },
  },
}
</script>
